import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { API_ENDPOINTS } from '@/constants';
import type { ApiResponse, TeacherStudentConnection } from '@/types';

/**
 * Returns whether the current student has any real (non-demo) teachers.
 * The backend already filters out demo teachers from the response.
 */
export function useHasRealTeachers(): boolean {
  const { data } = useQuery({
    queryKey: ['student', 'teachers'],
    queryFn: () =>
      api.get<never, ApiResponse<TeacherStudentConnection[]>>(
        API_ENDPOINTS.STUDENT_TEACHERS,
      ),
    staleTime: 5 * 60 * 1000, // 5 minutes — teacher list changes infrequently
  });

  const connections = data?.data ?? [];
  // Show the tab if the student has any active OR pending (INVITED) teacher connections
  return connections.some((c) => c.status === 'ACTIVE' || c.status === 'INVITED');
}
